import Configuracao from '../misc/Configuracao';
import { IModelo, ModeloMinutaBack } from '../modelo';
import { CategoriaMinuta } from "../modelo/Categoria";
import { MovimentoGEDTO } from "../modelo/MinutaMovimentos";
import { UsuarioStore } from '../store';
import fetch from './AxiosAdapter';

class ModeloDocumentoApi {

    private normalizarTipoMinuta(tipoMinuta: unknown): number {
        const extrair = (valor: unknown): number => {
            if (typeof valor === 'number' && Number.isFinite(valor)) {
                return valor;
            }
            if (typeof valor === 'string') {
                const convertido = Number(valor);
                return Number.isFinite(convertido) ? convertido : NaN;
            }
            if (valor && typeof valor === 'object') {
                return extrair((valor as any).codigo);
            }
            return NaN;
        };

        const codigo = extrair(tipoMinuta);
        if (Number.isFinite(codigo)) {
            return codigo;
        }

        throw new Error('Tipo de minuta inválido para montar URL de conteúdo.');
    }

    async modelosDoGabinetePorTipo(siglaGabinete: string, tipoMinuta: number): Promise<ModeloMinutaBack[]> {
        const url = Configuracao.urlBuscarModelosMinuta.replace('{GABINETE}', siglaGabinete).replace('{TIPO_MINUTA}', tipoMinuta.toString());

        const result = await fetch<ModeloMinutaBack[]>(url, {
            method: 'GET',
            cache: 'default',
            timeout: 90000
        });
        const modelos = result.data;
        return modelos;
    }

    async conteudoModeloDoProcesso(siglaGabinete, tipoMinuta, codigoModelo, identificadorProcesso: number): Promise<string> {
        const urlPadrao = true;
        const url = urlPadrao ? Configuracao.urlModelosMinuta : 'http://localhost:8080/pje-servicos-minuta/api/modelos/docx/';

        const result = await fetch(url + siglaGabinete + '/' + tipoMinuta + '/' + codigoModelo + '/' + identificadorProcesso + '/conteudo', {
            method: 'GET',
            cache: 'default'
        });
        const conteudoModeloHtml = result.data as string;
        return conteudoModeloHtml;
    }

    async conteudoModeloPadrao(tipoMinuta) {
        const result = await fetch(Configuracao.urlModelosMinutaPadrao + tipoMinuta, {
            method: 'GET',
            cache: 'default'
        });
        const conteudoModelo = result.data;
        return conteudoModelo;
    }

    async alteraConteudo(orgaoJulgador, tipoMinuta, modelo, categoria) {
        const tipoMinutaCodigo = this.normalizarTipoMinuta(tipoMinuta);
        let url = Configuracao.urlModelosMinuta + 'alteraConteudo/' + orgaoJulgador + '/' + tipoMinutaCodigo;
        url = url + (modelo.codigo ? '/' + modelo.codigo : '');
        if (!modelo.categorias) {
            modelo.categorias = [];
            if (categoria) {
                modelo.categorias.push(categoria);
            }
        }
        let result = await fetch(url, {
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST',
            cache: 'default',
            body: JSON.stringify(modelo)
        });

        if (result.status < 300) {
            if (modelo.codigo === undefined) {
                // buscando o novo modelo para retornar
                const location = result.headers?.location as string;
                if (!location) {
                    return modelo;
                }
                url = Configuracao.urlModelosMinuta + orgaoJulgador + '/' + tipoMinutaCodigo + location.substring(location.lastIndexOf('/'));
                result = await fetch(url);
                return result.data;
            } else {
                return modelo;
            }
        } else {
            const erro = result.data as any;
            throw new Error('Erro ao salvar modelo. ' + (erro?.mensagem || erro?.message || 'Falha inesperada.'));
        }
    }

    async gravarModelo(orgaoJulgador: string, tipoMinuta: number, modelo: IModelo, categoria: CategoriaMinuta, movimentoCNJ: MovimentoGEDTO) {
        modelo.gabinete = UsuarioStore.gabinete;
        modelo.categoria = categoria;
        modelo.movimentoCnj = movimentoCNJ

        const result = await fetch(Configuracao.urlModelosMinuta.replace('{COD_MODELO}', modelo.codigo?.toString() || '-1'), {
            headers: {
                'Content-Type': 'application/json'
            },
            method: modelo.codigo ? 'PUT' : 'POST',
            cache: 'default',
            body: JSON.stringify(IModelo.toModeloMinutaBack(modelo))
        });
        if (result.status < 300) {
            return result.headers.location?.split('/').pop();
        } else {
            const erro = result.data as any;
            throw new Error('Erro ao salvar modelo. ' + erro.mensagem);
        }
    }

    async excluirModelo(codigoModelo) {
        const result = await fetch(Configuracao.urlModelosMinutaDelete.replace("{COD_MODELO}", codigoModelo), {
            method: 'DELETE',
            cache: 'default'
        });
        return result;
    }

    async conteudoModelo(orgaoJulgador, tipoMinuta, codigoModelo, contenttype?) {
        const tipoMinutaCodigo = this.normalizarTipoMinuta(tipoMinuta);
        const result = await fetch(Configuracao.urlModelosMinutaAntigo + orgaoJulgador + '/' + tipoMinutaCodigo + '/' + codigoModelo + '/conteudo' + (contenttype && `?ContentType=${contenttype}` || ''), {
            method: 'GET',
            cache: 'default',
            silent: true,
        });
        const conteudoModelo = result.data;
        return conteudoModelo;
    }

}// charset=ISO-8859-1

export default new ModeloDocumentoApi();